import { gql } from '@lcs/shared/api';

export const saveMailboxDetailsMutation = gql`
   mutation SaveMailboxDetails(
      $mailbox: MailboxPostInput!
      $deletedMessageIds: [UInt!]!
      $hasDeletedMessages: Boolean = false
   ) {
      deleteMailboxMessages(ids: $deletedMessageIds) @include(if: $hasDeletedMessages)
      mailbox: saveMailbox(mailbox: $mailbox) {
         mailboxId
         password
         unavailablePromptId2
         temporaryUnavailablePromptId
         namePromptId
         operatorExtensionId
         busyPromptId
         temporaryUnavailablePromptId
         mailboxMessagesConnection {
            items {
               mailboxMessageId
               isRead
               isArchived
            }
         }
      }
   }
`;
